import Http from '../utils/http';

const http = new Http(`${process.env.URL_BASE}`);

const metodos = {
  verificarSeAceitouTermosEmVigor: (usuario) => {
    const url = `/GerenciadorDeTermos/VerificarSeUsuarioAceitouTermosEmVigor?login=${usuario}`;
    return http.get(url);
  },
  redirecionarParaOGerenciadorDeTermos: (usuario) => {
    const body = { login: usuario, returnUrl: location.host + location.pathname };
    http.post('GerenciadorDeTermos', body).then((response) => {
      window.location = response.data.url;
    });
  },
};

/* eslint-disable no-param-reassign, no-unused-vars */
const plugin = {
  install(Vue, options) {
    Vue.prototype.$gerenciadorDeTermos = metodos;
  },
};

export default plugin;


// WEBPACK FOOTER //
// ./src/plugins/gerenciadorDeTermos.js